import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import '../edeeshop/jquery.fulltextAutocomplete';

export default class FulltextSearch extends WebComponent {
  didMount() {
      const fulltextRadioOptions = document.getElementById('fulltextOptionsRadio').querySelectorAll('input[type=radio]');
      const optWeb = document.getElementById('optWeb');
      const optDocs = document.getElementById('optDocs');
      const optEshop = document.getElementById('optEshop');
      const fulltextForm = document.getElementById('headerSearchForm');
      const fulltextSearchBtn = document.getElementById('fulltextSearchBtn');
      const fulltextFacultyFilter = document.getElementById('facultyCategory__container');
      const fulltextFacultyFilterSelect = document.getElementById('facultyCategory');
      const fulltextOptionsGroup = document.getElementById('fulltextOptionsGroup');
      let autocompleteUrl = 'fulltextMainContentUhkPointAutocompleteResult';

      if(optDocs.checked) {
          autocompleteUrl = 'fulltextDocumentsUhkPointAutocompleteResult';
      } else if (optEshop && optEshop.checked) {
          autocompleteUrl = 'fulltextAutocompleteResult';
      }

      $(fulltextForm).fulltextAutocomplete({
          url: `/qf/${window.projectConfig.lang}/ramjet/`+autocompleteUrl,
          lang: window.projectConfig.lang
      });

      /**
     * Actual Ajax query
     */
    fulltextSearchBtn.onclick = function (e) {
      e.preventDefault();
      /* TODO - MAL - would be nice to remove jQuerys' AJAX load */

      //console.log('click',fulltextformAction, $(".fulltext__results").load(fulltextformAction + '?frm.query=' + encodeURI(fulltextformQuery) + ' #result'));
      /*var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          document.getElementById("fulltextResultsContainer").innerHTML = this.responseText;
          console.log(this.responseText);
        }
      };
      xhttp.open("GET", fulltextformAction + '?frm.query=' + encodeURI(fulltextformQuery), true);
      xhttp.send();*/

      const autocompleteResults = document.getElementById('resultAutocomplete');

      /**
       * Hiding autocomplete results
       */
      if (autocompleteResults) {
        autocompleteResults.classList.add('visually-hidden');
      }

      /**
       * Showing faculty filter
       */
      fulltextFacultyFilter.classList.remove('visually-hidden');

      /**
       * Get radios
       * @type {NodeListOf<Element>}
       */

      if(optWeb.checked) {
        // show faculty filter
        fulltextFacultyFilter.classList.remove('visually-hidden');
        // query build up
        const fulltextForm = document.getElementById('headerSearchForm');
        const fulltextformQuery = document.getElementById('query').value;
        const fulltextformAction = fulltextForm.getAttribute('action');
        if(fulltextformAction.startsWith("/qf/cs/")){
          fulltextForm.setAttribute('action', '/qf/cs/ramjet/helpzone/vyhledavani-obsah');
        } else if(fulltextformAction.startsWith("/qf/en/")){
          fulltextForm.setAttribute('action', '/qf/en/ramjet/helpzone/search-content');
        }
        $("#fulltextResultsContainer").load(fulltextForm.getAttribute('action') + '?frm.query=' + encodeURI(fulltextformQuery) + ' #result');
      } else if (optDocs.checked) {
        console.log('docs');

       // hide faculty filter
        fulltextFacultyFilter.classList.add('visually-hidden');

        // query build up
        const fulltextForm = document.getElementById('headerSearchForm');
        const fulltextformQuery = document.getElementById('query').value;
        const fulltextformAction = fulltextForm.getAttribute('action');

        if(fulltextformAction.startsWith("/qf/cs/")){
           fulltextForm.setAttribute('action', '/qf/cs/ramjet/helpzone/vyhledavani-souboru');
        } else if(fulltextformAction.startsWith("/qf/en/")){
           fulltextForm.setAttribute('action', '/qf/en/ramjet/helpzone/search-files');
        }
        $("#fulltextResultsContainer").load(fulltextForm.getAttribute('action') + '?frm.query=' + encodeURI(fulltextformQuery) + ' #result');
      } else if (optEshop.checked) {
        // hide faculty filter
        fulltextFacultyFilter.classList.add('visually-hidden');

        // query build up
        const fulltextForm = document.getElementById('headerSearchForm');
        const fulltextformQuery = document.getElementById('query').value;
        const fulltextformAction = fulltextForm.getAttribute('action');

        if(fulltextformAction.startsWith("/qf/cs/")){
            fulltextForm.setAttribute('action', '/qf/cs/ramjet/vyhledavani-eshop');
        } else if(fulltextformAction.startsWith("/qf/en/")){
            fulltextForm.setAttribute('action', '/qf/en/ramjet/search-eshop');
        }
        $("#fulltextResultsContainer").load(fulltextForm.getAttribute('action') + '?frm.query=' + encodeURI(fulltextformQuery) + ' #result');
      }
    };

    /**
     * Handling click events on radios
     */
    for (var i = 0; i < fulltextRadioOptions.length; i++) {
        fulltextRadioOptions[i].onclick = function () {
            const fulltextResultsContainer = document.getElementById('fulltextResultsContainer');
            fulltextResultsContainer.innerHTML = '';
            if (typeof (fulltextSearchBtn.childNodes[0]).classList !== 'undefined') {
                fulltextSearchBtn.childNodes[0].classList.toggle('active');
            }
            // when searching in documents, don't show the faculty filter
            destroyAutocomplete();
            if (this.id === 'optWeb') {
                fulltextFacultyFilter.classList.remove('d-none');
                $(fulltextForm).fulltextAutocomplete({
                    url: `/qf/${window.projectConfig.lang}/ramjet/fulltextMainContentUhkPointAutocompleteResult`,
                    lang: window.projectConfig.lang,
                });
                fulltextFacultyFilterSelect.selectedIndex = '0'; // reset select to default
                fulltextFacultyFilter.classList.add('active');
            } else if (this.id === 'optDocs') {
                fulltextFacultyFilter.classList.add('d-none');
                $(fulltextForm).fulltextAutocomplete({
                    url: `/qf/${window.projectConfig.lang}/ramjet/fulltextDocumentsUhkPointAutocompleteResult`,
                    lang: window.projectConfig.lang,
                });
                fulltextFacultyFilter.classList.remove('active');
            } else if (this.id === 'optEshop') {
                fulltextFacultyFilter.classList.add('d-none');
                $(fulltextForm).fulltextAutocomplete({
                    url: `/qf/${window.projectConfig.lang}/ramjet/fulltextAutocompleteResult`,
                    lang: window.projectConfig.lang,
                });
                fulltextFacultyFilter.classList.remove('active');
            }  else {
                fulltextFacultyFilter.classList.add('d-none');
                fulltextFacultyFilter.classList.remove('active');
            }
            const fulltextformQuery = document.getElementById('query').value;
            if(fulltextformQuery !== '') $(fulltextSearchBtn).click(); // do click to show results straight away
        };
    }

	if(document.body.classList.contains('eshop')) {
	  optEshop.click();
	}

    function destroyAutocomplete() {
        $(fulltextForm).unbind().removeData();
        $('#query').unbind().removeData();
        $('.fulltext-autocomplete').remove();
    }

    // load product images after ajax request
	$(document).ajaxComplete(function( event, xhr, settings ) {
      if ( settings.url.indexOf("/qf/cs/ramjet/vyhledavani-eshop") !== -1 || settings.url.indexOf("/qf/en/ramjet/search-eshop") !== -1) {
          $("#fulltextResultsContainer .product-list__motive.lazy").each(function() {
            this.src = this.dataset.src;
          });
          // TODO tady by stálo za to, vymyslet nějak lépe
          $("#fulltextResultsContainer a").each(function() {
          this.href = this.href.replace('http://helpzone.dev.fg.cz','http://uhk.dev.fg.cz').replace('https://test-helpzone.uhk.cz','https://test-fg.uhk.cz').replace('https://www.helpzone.cz','https://www.uhk.cz');
        });
      }
        if ( settings.url.indexOf("/qf/cs/ramjet/helpzone/vyhledavani-obsah") !== -1 ||
            settings.url.indexOf("/qf/en/ramjet/helpzone/search-content") !== -1 ||
            settings.url.indexOf("/qf/cs/ramjet/helpzone/vyhledavani-souboru") !== -1 ||
            settings.url.indexOf("/qf/en/ramjet/helpzone/search-files") !== -1) {
            const fulltextTitles = $('#fulltextResultsContainer .fulltext-list__title');
            let ariaText = '';
            if (fulltextTitles.length > 0) {
                fulltextTitles.each(function(index) {
                    if (index > 0) ariaText += ', ';
                    ariaText += $(this).text();
                });
            }
            $('#fulltextResultsContainer .fulltext-list__title:eq(0)').attr('aria-label',ariaText).focus();
        }
    });

  }
}



// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/components/FulltextSearch.js